<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseStyleAddApplyList.push"
    :query-list="queryList"
  >
    <div slot="header-item">
      <v-select-apply-state
        class="table-filter-select"
        v-model="queryList.apply_state"
        @input="handleApplyStateChange"
        size="small"
        placeholder="审核状态"
      />
    </div>
    <v-column-time value="申请时间"/>
    <v-column-avatar label="申请者"/>
    <el-table-column
      v-if="isAdministrator"
      label="申请门店"
      width="150"
      align="center"
      prop="store_name"
    />
    <el-table-column label="舞蹈风格名称" width="150" align="center" prop="style_name"/>

    <el-table-column label="审核状态" width="150" align="center">
      <template v-slot="{ row }">
        <span
          v-for="applyState in findApplyState(row.apply_state)"
          :class="`${applyState.tagType}-color`"
          :key="`applyStateValue${applyState.value}`"
        >
          {{ applyState.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="244px">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="view"
          :to="RouteConfig.courseStyleAddApplyDetail.to(row.id)"
        />

        <template v-if="row.update_state === applyStates.review.value">
          <v-list-button
            v-if="isAdministrator"
            name="驳回"
            icon="reject"
            @click="handleReject(row)"
            :is-loading="isRejectingIds.includes(row.id)"
            :is-last="true"
            message="确定要驳回申请吗？"
          />

          <v-list-button
            v-else
            name="撤销"
            icon="restore"
            @click="handleRevoke(row)"
            :is-loading="isRevokingIds.includes(row.id)"
            :is-last="true"
            message="确定要撤销申请吗？"
          />
        </template>
      </template>
    </el-table-column>

    <v-dialog-update-record
      v-model="isShowDialog"
      :is-loading="isDetailLoading"
      :update-info="applyInfo"
      :is-passing-ids="isPassingIds"
      :is-rejecting-ids="isRejectingIds"
      :is-revoking-ids="isRevokingIds"
      @back="isShowDialog = false"
      @pass="handlePass"
      @reject="handleReject"
      @revoke="handleRevoke"
    />

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>申请时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>申请者</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>申请门店</span>
              <span>{{ v.store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>舞蹈风格名称</span>
              <span>{{ v.style_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>审核状态</span>
              <span
                v-for="applyState in findApplyState(v.apply_state)"
                :class="`${applyState.tagType}-color`"
                :key="`applyStateValue${applyState.value}`"
              >
                {{ applyState.name }}
              </span>
            </div>

            <div class="list-item-button">
              <template v-if="isAdministrator">
                <v-list-button
                  name="查看"
                  icon="view"
                  :to="RouteConfig.courseStyleAddApplyDetail.to(v.id)"
                />

                <template v-if="v.update_state === applyStates.review.value">
                  <v-list-button
                    v-if="isAdministrator"
                    name="驳回"
                    icon="reject"
                    @click="handleReject(v)"
                    :is-loading="isRejectingIds.includes(v.id)"
                    :is-last="true"
                    message="确定要驳回申请吗？"
                  />

                  <v-list-button
                    v-else
                    name="撤销"
                    icon="restore"
                    @click="handleRevoke(v)"
                    :is-loading="isRevokingIds.includes(v.id)"
                    :is-last="true"
                    message="确定要撤销申请吗？"
                  />
                </template>
              </template>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>

</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import updateTypes from '@/enums/cardUpdateTypes';
import { applyStates, findApplyState } from '@/enums/applyStates';
import {
  index,
  show,
  pass,
  reject,
  revoke,
} from '@/api/course-style-add-apply';
import { removeArrayItem } from '@/utils';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.cardDeleteApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      apply_state: applyStates.review.value,
      page: 1,
      size: 8,
    },
    isLoading: false,
    isDetailLoading: false,
    isShowDialog: false,
    isShowPassAllTip: false,
    isPassingAll: false,
    isRevokingIds: [],
    isPassingIds: [],
    isRejectingIds: [],
    applyInfo: {
      id: 0,
      update_state: applyStates.review.value,
      update_remark: '',
      store: {},
      administrator: {},
      student: {},
      old_student: {},
      card_name: '',
      card_type_name: '',
      card_number: '',
      is_generic: 0,
      is_number_limit: 0,
      is_private: 0,
      expire_number: 0,
      expire_days: 0,
      expire_time: 0,
      actual_payment: 0,
      card_payment_mode_name: '',
      payment_remark: '',
      old_card_name: '',
      old_card_type_name: '',
      old_card_number: '',
      old_is_generic: 0,
      old_is_number_limit: 0,
      old_is_private: 0,
      old_expire_number: 0,
      old_expire_days: 0,
      old_expire_time: 0,
      old_actual_payment: 0,
      old_card_payment_mode_name: '',
      old_payment_remark: '',
    },
    updateTypes,
    applyStates,
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findApplyState,
    closeModal(id) {
      if (this.applyInfo.id !== id) return;
      this.applyInfo.id = 0;
      this.isShowDialog = false;
    },
    refresh() {
      RouteConfig.courseStyleAddApplyList.push(this.queryList);
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleApplyStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async showDialog({ id }) {
      if (this.isShowDialog) return;

      this.isShowDialog = true;
      if (this.applyInfo.id === id) return;

      this.isDetailLoading = true;
      const { isError, data } = await show(id);
      this.isDetailLoading = false;
      if (isError) return;

      this.applyInfo = data;
    },
    async handleRevoke({ id }) {
      this.isRevokingIds.push(id);
      const { isError } = await revoke(id);
      removeArrayItem(this.isRevokingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
    async handleReject({ id }) {
      this.isRejectingIds.push(id);
      const { isError } = await reject(id);
      removeArrayItem(this.isRejectingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
    async handlePass(applyInfo) {
      const { id } = applyInfo;
      const { isPassingIds } = this;
      if (isPassingIds.includes(id)) return;

      isPassingIds.push(id);
      applyInfo.showPassTip = false;
      const { isError } = await pass(id);
      removeArrayItem(isPassingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
  },
};
</script>
